module.exports = "/365FarmNet/dist/cropPlanningOperation.4a59cc174d44a187abfe34f05a734276.html";